import { IconMail01, IconPhone } from "@pentabd/icons";
import { Text } from "@pentabd/ui";

import { EmployeeCommonInfoType } from "@type/HRM/employee-common-info";

export const ContactColumn = ({
  employee: { mobileNumber, email },
}: {
  employee: EmployeeCommonInfoType;
}) => {
  return (
    <div className="d-flex flex-column gap-4">
      <div className="d-flex gap-2 align-items-center">
        <IconPhone size={16} fill="title" />
        <Text color="title">{mobileNumber}</Text>
      </div>
      <div className="d-flex gap-2 align-items-center">
        <IconMail01 size={16} fill="success" />
        <Text color="success">{email}</Text>
      </div>
    </div>
  );
};
